var BASE_URL = "https://datapost.site";
var API_URL = BASE_URL + "/api/customer-report";
var TEAM_API = BASE_URL + "/api/team-detail";

/* ════════════════════════════════════════════════════
   HELPERS
   ════════════════════════════════════════════════════ */

function formatBytes(bytes) {
  if (!bytes) return '0 B';
  var k = 1024, sizes = ['B','KB','MB','GB','TB'];
  var i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
}

function formatNumber(n) {
  if (n == null) return '0';
  return Number(n).toLocaleString();
}

function formatMoney(n) {
  if (n == null) return '$0';
  return '$' + Number(n).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
}

function relDate(d) {
  if (!d) return '—';
  var date = new Date(d);
  var now = new Date();
  var diff = Math.floor((now - date) / 86400000);
  if (diff < 1) return 'Today';
  if (diff === 1) return 'Yesterday';
  if (diff < 30) return diff + ' days ago';
  if (diff < 365) return Math.floor(diff / 30) + ' mo ago';
  return Math.floor(diff / 365) + 'y ago';
}

function escapeHtml(str) {
  var div = document.createElement('div');
  div.textContent = str || '';
  return div.innerHTML;
}

/* ════════════════════════════════════════════════════
   TABS
   ════════════════════════════════════════════════════ */

function initTabs() {
  document.querySelectorAll('.tp-tab').forEach(function(tab) {
    tab.addEventListener('click', function() {
      document.querySelectorAll('.tp-tab').forEach(function(t) { t.classList.remove('active'); });
      document.querySelectorAll('.tp-panel').forEach(function(p) { p.classList.remove('active'); });
      tab.classList.add('active');
      document.getElementById(tab.dataset.panel).classList.add('active');
    });
  });
}

/* ════════════════════════════════════════════════════
   TEAM LIST
   ════════════════════════════════════════════════════ */

function loadTeams() {
  var grid = document.getElementById('team-grid');
  if (!grid) return;

  axios.get(TEAM_API).then(function(res) {
    var teams = res.data.teams || [];
    // Sort by device count descending
    teams.sort(function(a, b) { return (b.devices || 0) - (a.devices || 0); });
    // Filter out teams with 0 devices
    var active = teams.filter(function(t) { return t.devices > 0; });

    // Store for leaderboard
    window._teamsData = active;

    grid.innerHTML = '';
    active.forEach(function(team) {
      var card = document.createElement('div');
      card.className = 'tp-card';
      card.setAttribute('role', 'button');
      card.setAttribute('tabindex', '0');
      card.onclick = function() { loadTeamDetail(team.slug); };
      card.onkeydown = function(e) { if (e.key === 'Enter') loadTeamDetail(team.slug); };

      var imgSrc = team.photoUrl || '';
      var imgHtml = imgSrc
        ? '<img class="tp-card-img" src="' + escapeHtml(imgSrc) + '" alt="' + escapeHtml(team.name) + '" loading="lazy">'
        : '<div class="tp-card-img" style="display:flex;align-items:center;justify-content:center;color:#aaa;font-size:2.5rem;">&#x1f310;</div>';

      card.innerHTML = imgHtml +
        '<div class="tp-card-body">' +
          '<h3>' + escapeHtml(team.name) + '</h3>' +
          '<p>' + escapeHtml(team.mission || '') + '</p>' +
          '<div class="tp-card-stats">' +
            '<span>&#x1f4f1; ' + (team.devices || 0) + ' devices</span>' +
            '<span>&#x1f6B4; ' + (team.couriers || 0) + ' couriers</span>' +
          '</div>' +
        '</div>';

      grid.appendChild(card);
    });

    // Build leaderboard from same data
    renderLeaderboard(active);
  }).catch(function(err) {
    grid.innerHTML = '<p style="color:#c00;">Unable to load teams. Please try again later.</p>';
    console.error(err);
  });
}

/* ════════════════════════════════════════════════════
   LEADERBOARD
   ════════════════════════════════════════════════════ */

function renderLeaderboard(teams) {
  var container = document.getElementById('leaderboard-content');
  if (!container) return;

  // We need detailed data for each team to rank by visitors/bandwidth etc.
  // Fetch all team details in parallel
  var slugs = teams.map(function(t) { return t.slug; });
  var promises = slugs.map(function(slug) {
    return axios.get(TEAM_API + '?slug=' + encodeURIComponent(slug))
      .then(function(res) { return res.data; })
      .catch(function() { return null; });
  });

  Promise.all(promises).then(function(details) {
    var enriched = details.filter(function(d) { return d && d.summary; });

    var html = '';

    // Most Devices
    var byDevices = enriched.slice().sort(function(a, b) { return (b.summary.devices || 0) - (a.summary.devices || 0); });
    html += leaderboardSection('&#x1f4f1; Most Devices', byDevices, function(t) {
      return formatNumber(t.summary.devices) + ' devices';
    });

    // Most Visitors
    var byVisitors = enriched.slice().sort(function(a, b) { return (b.summary.visitors || 0) - (a.summary.visitors || 0); });
    html += leaderboardSection('&#x1f465; Most Visitors', byVisitors, function(t) {
      return formatNumber(t.summary.visitors) + ' visitors';
    });

    // Most Bandwidth
    var byBandwidth = enriched.slice().sort(function(a, b) { return (b.summary.bandwidth || 0) - (a.summary.bandwidth || 0); });
    html += leaderboardSection('&#x1f4e1; Most Bandwidth Served', byBandwidth, function(t) {
      return formatBytes(t.summary.bandwidth);
    });

    // Most Deliveries
    var byDeliveries = enriched.slice().sort(function(a, b) { return (b.summary.deliveries || 0) - (a.summary.deliveries || 0); });
    html += leaderboardSection('&#x1f69a; Most Deliveries', byDeliveries, function(t) {
      return formatNumber(t.summary.deliveries) + ' deliveries';
    });

    // Highest Value Saved
    var byValue = enriched.slice().sort(function(a, b) { return (b.summary.valueSaved || 0) - (a.summary.valueSaved || 0); });
    html += leaderboardSection('&#x1f4b0; Highest Value of Data Saved', byValue, function(t) {
      return formatMoney(t.summary.valueSaved);
    });

    // Most Couriers
    var byCouriers = enriched.slice().sort(function(a, b) { return (b.summary.couriers || 0) - (a.summary.couriers || 0); });
    html += leaderboardSection('&#x1f6b4; Most Couriers', byCouriers, function(t) {
      return formatNumber(t.summary.couriers) + ' couriers';
    });

    container.innerHTML = html;
  }).catch(function() {
    container.innerHTML = '<p style="color:#c00;">Unable to load leaderboard data.</p>';
  });
}

function leaderboardSection(title, teams, valueFn) {
  var html = '<div class="lb-section"><h3>' + title + '</h3>';
  var top = teams.slice(0, 10);
  top.forEach(function(team, i) {
    var rankClass = i === 0 ? 'gold' : i === 1 ? 'silver' : i === 2 ? 'bronze' : 'other';
    var imgHtml = team.photoUrl
      ? '<img class="lb-img" src="' + escapeHtml(team.photoUrl) + '" alt="" loading="lazy">'
      : '<div class="lb-img" style="background:#e8eff2;display:flex;align-items:center;justify-content:center;color:#aaa;font-size:1.2rem;">&#x1f310;</div>';
    html += '<div class="lb-row" onclick="loadTeamDetail(\'' + escapeHtml(team.slug) + '\'); document.querySelector(\'[data-panel=teams-panel]\').click();">' +
      '<div class="lb-rank ' + rankClass + '">' + (i + 1) + '</div>' +
      imgHtml +
      '<div class="lb-info">' +
        '<div class="lb-name">' + escapeHtml(team.name) + '</div>' +
        '<div class="lb-mission">' + escapeHtml(team.mission || '') + '</div>' +
      '</div>' +
      '<div class="lb-val">' + valueFn(team) + '</div>' +
    '</div>';
  });
  html += '</div>';
  return html;
}

/* ════════════════════════════════════════════════════
   TEAM DETAIL
   ════════════════════════════════════════════════════ */

var currentTeamMap = null;

function loadTeamDetail(slug) {
  var listView = document.getElementById('team-list-view');
  var detailView = document.getElementById('team-detail-view');
  listView.style.display = 'none';
  detailView.style.display = 'block';
  detailView.innerHTML = '<div class="tp-loading"><div class="tp-spinner"></div><p>Loading team data…</p></div>';

  axios.get(TEAM_API + '?slug=' + encodeURIComponent(slug)).then(function(res) {
    var d = res.data;
    renderTeamDetail(d, detailView);
  }).catch(function(err) {
    detailView.innerHTML = '<p style="color:#c00;">Unable to load team data.</p>';
    console.error(err);
  });
}

function showTeamList() {
  document.getElementById('team-list-view').style.display = '';
  document.getElementById('team-detail-view').style.display = 'none';
  if (currentTeamMap) { currentTeamMap.remove(); currentTeamMap = null; }
}

function renderTeamDetail(d, container) {
  var s = d.summary || {};
  var imgHtml = d.photoUrl
    ? '<img src="' + escapeHtml(d.photoUrl) + '" alt="' + escapeHtml(d.name) + '">'
    : '';
  var websiteHtml = d.website
    ? '<a href="' + escapeHtml(d.website) + '" target="_blank" rel="noopener">' + escapeHtml(d.website) + '</a>'
    : '';

  var html = '<button class="tp-back" onclick="showTeamList()">&#x2190; All Teams</button>';

  // Header
  html += '<div class="tp-header">' +
    imgHtml +
    '<div class="tp-header-info">' +
      '<h2>' + escapeHtml(d.name) + '</h2>' +
      '<p>' + escapeHtml(d.mission || '') + '</p>' +
      websiteHtml +
    '</div></div>';

  // Impact cards
  html += '<div class="tp-impact">' +
    impactCard(formatMoney(s.valueSaved), 'Value of Data Saved') +
    impactCard(formatNumber(s.visitors), 'Total Visitors') +
    impactCard(formatBytes(s.bandwidth), 'Bandwidth Served') +
    impactCard(formatNumber(s.requests), 'Content Requests') +
    impactCard(formatNumber(s.devices), 'Devices') +
    impactCard(formatNumber(s.deliveries), 'Deliveries') +
  '</div>';

  // Map placeholder
  html += '<h3 style="color:#1a3b4a;">Device Locations</h3>';
  html += '<div id="tp-team-map" class="tp-map"></div>';

  // Device table
  html += '<h3 style="color:#1a3b4a;">Device Usage</h3>';
  html += '<div class="tp-table-wrap"><table class="tp-table" id="device-table">' +
    '<thead><tr>' +
      '<th data-col="0">Name <span class="sort-arrow"></span></th>' +
      '<th data-col="1">Visitors <span class="sort-arrow"></span></th>' +
      '<th data-col="2">Bandwidth <span class="sort-arrow"></span></th>' +
      '<th data-col="3">Requests <span class="sort-arrow"></span></th>' +
      '<th data-col="4">Couriers <span class="sort-arrow"></span></th>' +
      '<th data-col="5">Last Delivery <span class="sort-arrow"></span></th>' +
      '<th data-col="6">Last Sync <span class="sort-arrow"></span></th>' +
    '</tr></thead><tbody>';

  var devices = d.deviceStats || [];
  devices.forEach(function(dev) {
    html += '<tr>' +
      '<td>' + escapeHtml(dev.name || dev.subdomain) + '</td>' +
      '<td>' + formatNumber(dev.visitors) + '</td>' +
      '<td data-sort="' + (dev.bandwidth || 0) + '">' + formatBytes(dev.bandwidth) + '</td>' +
      '<td>' + formatNumber(dev.requests) + '</td>' +
      '<td>' + (dev.courierCount || 0) + '</td>' +
      '<td data-sort="' + (dev.lastDelivery || '') + '">' + relDate(dev.lastDelivery) + '</td>' +
      '<td>' + escapeHtml(dev.lastDataSync || '—') + '</td>' +
    '</tr>';
  });
  html += '</tbody></table></div>';

  // Courier table
  var couriers = d.courierStats || [];
  if (couriers.length) {
    html += '<h3 style="color:#1a3b4a;">Courier Performance</h3>';
    html += '<div class="tp-table-wrap"><table class="tp-table" id="courier-table">' +
      '<thead><tr>' +
        '<th data-col="0">Email <span class="sort-arrow"></span></th>' +
        '<th data-col="1">Deliveries <span class="sort-arrow"></span></th>' +
        '<th data-col="2">Pickups <span class="sort-arrow"></span></th>' +
        '<th data-col="3">Last Active <span class="sort-arrow"></span></th>' +
      '</tr></thead><tbody>';
    couriers.forEach(function(c) {
      html += '<tr>' +
        '<td>' + escapeHtml(c.email || c.name || '—') + '</td>' +
        '<td>' + (c.deliveries || 0) + '</td>' +
        '<td>' + (c.pickups || 0) + '</td>' +
        '<td data-sort="' + (c.lastActive || '') + '">' + relDate(c.lastActive) + '</td>' +
      '</tr>';
    });
    html += '</tbody></table></div>';
  }

  container.innerHTML = html;

  // Render map
  renderTeamMap(d.locations || []);

  // Make tables sortable
  initSortable('device-table');
  if (couriers.length) initSortable('courier-table');
}

function impactCard(val, label) {
  return '<div class="tp-impact-card"><div class="val">' + val + '</div><div class="label">' + label + '</div></div>';
}

/* ════════════════════════════════════════════════════
   TEAM MAP
   ════════════════════════════════════════════════════ */

function renderTeamMap(locations) {
  var el = document.getElementById('tp-team-map');
  if (!el || !locations.length) {
    if (el) el.style.display = 'none';
    return;
  }

  var map = L.map('tp-team-map').setView([locations[0].lat, locations[0].lng], 3);
  currentTeamMap = map;

  L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
    maxZoom: 18,
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
  }).addTo(map);

  var bounds = [];
  locations.forEach(function(loc) {
    if (!loc.lat || !loc.lng) return;
    var latlng = [loc.lat, loc.lng];
    bounds.push(latlng);
    L.marker(latlng).addTo(map)
      .bindPopup('<strong>' + escapeHtml(loc.name || loc.subdomain) + '</strong><br><small>' + escapeHtml(loc.subdomain) + '</small>');
  });
  if (bounds.length > 1) map.fitBounds(bounds, { padding: [30, 30] });
  else if (bounds.length === 1) map.setView(bounds[0], 7);
}

/* ════════════════════════════════════════════════════
   SORTABLE TABLES
   ════════════════════════════════════════════════════ */

function initSortable(tableId) {
  var table = document.getElementById(tableId);
  if (!table) return;
  var headers = table.querySelectorAll('th');
  var sortState = { col: -1, asc: true };

  headers.forEach(function(th) {
    th.addEventListener('click', function() {
      var col = parseInt(th.dataset.col);
      if (sortState.col === col) sortState.asc = !sortState.asc;
      else { sortState.col = col; sortState.asc = true; }

      var tbody = table.querySelector('tbody');
      var rows = Array.from(tbody.querySelectorAll('tr'));
      rows.sort(function(a, b) {
        var cellA = a.children[col];
        var cellB = b.children[col];
        var vA = cellA.dataset.sort !== undefined ? cellA.dataset.sort : cellA.textContent.trim();
        var vB = cellB.dataset.sort !== undefined ? cellB.dataset.sort : cellB.textContent.trim();
        var nA = parseFloat(vA.replace(/[^0-9.\-]/g, ''));
        var nB = parseFloat(vB.replace(/[^0-9.\-]/g, ''));
        if (!isNaN(nA) && !isNaN(nB)) return sortState.asc ? nA - nB : nB - nA;
        return sortState.asc ? vA.localeCompare(vB) : vB.localeCompare(vA);
      });
      rows.forEach(function(r) { tbody.appendChild(r); });

      // Update arrows
      headers.forEach(function(h) { h.querySelector('.sort-arrow').textContent = ''; });
      th.querySelector('.sort-arrow').textContent = sortState.asc ? ' ▲' : ' ▼';
    });
  });
}

/* ════════════════════════════════════════════════════
   ORDER REPORT (existing functionality)
   ════════════════════════════════════════════════════ */

function getOrdersData() {
  var el = document.getElementById('orderNumbers');
  if (!el) return;
  var orderNumbers = Array.from(el.selectedOptions).map(function(opt) { return opt.value; });

  if (!orderNumbers.length) { alert('Please select at least one order.'); return; }
  for (var i = 0; i < orderNumbers.length; i++) {
    if (!orderNumbers[i] || isNaN(orderNumbers[i])) { alert('Invalid order number.'); return; }
  }

  axios.post(API_URL, { orderNumbers: orderNumbers }, {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  }).then(function(response) {
    var container = document.querySelector('#datapost-data-container');
    container.innerHTML = '';
    renderOrderSummary(response.data, container);
    renderOrderMap(response.data, container);
    renderOrderCharts(response.data, container);
    renderOrderModules(response.data, container);
    document.body.style.height = 'auto';
  }).catch(function(error) {
    console.error(error);
    alert('Error fetching report. Please try again.');
  });
}

function renderOrderSummary(data, container) {
  var div = document.createElement('div');
  div.innerHTML =
    '<h2 style="text-align:center">Summary</h2>' +
    '<div style="overflow-x:auto;margin-bottom:2rem"><table class="tp-table"><thead><tr>' +
    '<th>Total Devices</th><th>Devices Reporting</th><th>Not Reporting</th>' +
    '</tr></thead><tbody><tr>' +
    '<td style="text-align:center">' + data.deviceCount + '</td>' +
    '<td style="text-align:center">' + data.devicesReportingData + '</td>' +
    '<td style="text-align:center">' + data.devicesNotReportingData + '</td>' +
    '</tr></tbody></table></div>';
  container.appendChild(div);
}

function renderOrderMap(data, container) {
  if (!data.apLocations || !Object.keys(data.apLocations).length) return;
  var wrapper = document.createElement('div');
  wrapper.innerHTML = '<div id="order-map" style="width:100%;height:450px;border-radius:10px;margin-bottom:2rem;"></div>';
  container.appendChild(wrapper);

  var map = L.map('order-map').setView([15.7833, -90.2308], 3);
  L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
    maxZoom: 18,
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
  }).addTo(map);

  var bounds = [];
  for (var sub in data.apLocations) {
    var latlng = data.apLocations[sub];
    bounds.push(latlng);
    L.marker(latlng).addTo(map).bindPopup('<strong>' + escapeHtml(sub) + '</strong>');
  }
  if (bounds.length > 1) map.fitBounds(bounds, { padding: [30, 30] });
}

function renderOrderCharts(data, container) {
  if (!data.charts || !data.charts.length) return;
  var wrap = document.createElement('div');
  wrap.style.margin = '2rem 0';
  container.appendChild(wrap);
  data.charts.forEach(function(chartData) {
    var div = document.createElement('div');
    div.style.marginBottom = '2rem';
    var canvas = document.createElement('canvas');
    canvas.id = chartData.id;
    canvas.style.maxHeight = '60vh';
    canvas.style.width = '100%';
    div.appendChild(canvas);
    wrap.appendChild(div);
    Chart.defaults.font.size = 16;
    new Chart(canvas.getContext('2d'), chartData.config);
  });
}

function renderOrderModules(data, container) {
  if (!data.modulesByUsage || !data.modulesByUsage.length) return;
  var div = document.createElement('div');
  div.innerHTML = '<h2 style="text-align:center">Modules by Usage</h2>';
  container.appendChild(div);
  data.modulesByUsage.forEach(function(chart) {
    var canvas = document.createElement('canvas');
    canvas.id = chart.id;
    canvas.style.maxHeight = '60vh';
    div.appendChild(canvas);
    new Chart(canvas, chart.config);
  });
}

/* ════════════════════════════════════════════════════
   INIT
   ════════════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', function() {
  // Tabs
  initTabs();

  // Load teams
  loadTeams();

  // Order form (if logged in)
  var orderEl = document.getElementById('orderNumbers');
  if (orderEl && typeof Choices !== 'undefined') {
    new Choices(orderEl, {
      removeItemButton: true, maxItemCount: -1,
      searchEnabled: true, singleModeForMultiSelect: false
    });
  }
  var orderForm = document.getElementById('custom-report-form');
  if (orderForm) {
    orderForm.addEventListener('submit', function(e) {
      e.preventDefault();
      getOrdersData();
    });
  }
});
